import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import LongTextValue from "./controls/LongTextValue";
import { useDialog } from "./controls/Dialog";
import { useFormikContext } from "formik";
import { listarRelacionesOperacionUnitaria } from "../utils/data";

export function OperacionUnitariaList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const dialog = useDialog({ showing: false, variant: "warning" });
  const handleDeleteClick = (index) => (event) => {
    event.preventDefault();
    const item = tramiteForm.values.operacionesUnitarias[index];
    if (!!item) {
      const relacionados = listarRelacionesOperacionUnitaria(item, tramiteForm);
      if (
        relacionados.productosElaborados.length > 0 ||
        relacionados.sustanciasQuimicas.length > 0 ||
        relacionados.fuentesEfluentesLiquidos.length > 0 ||
        relacionados.residuosSolidosUrbanos.length > 0 ||
        relacionados.residuosPeligrosos.length > 0 ||
        relacionados.residuosPatogenicos.length > 0 ||
        relacionados.ductos.length > 0
      ) {
        dialog.display(
          t("operacionUnitariaForm.dialog.remove.title"),
          <>
            <p>{t("operacionUnitariaForm.dialog.remove.message")}</p>
            <ul>
              {relacionados.productosElaborados.length > 0 && (
                <li>
                  <div>{t("tramite.productosElaborados")}</div>
                  <ul>
                    {relacionados.productosElaborados.map((producto) => (
                      <li>{producto.nombre}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.sustanciasQuimicas.length > 0 && (
                <li>
                  <div>{t("tramite.sustanciasQuimicas")}</div>
                  <ul>
                    {relacionados.sustanciasQuimicas.map((sustancia) => (
                      <li>
                        {sustancia.nombreComercial}&nbsp;(
                        {sustancia.nombreQuimico})
                      </li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.fuentesEfluentesLiquidos.length > 0 && (
                <li>
                  <div>{t("tramite.fuentesEfluentesLiquidos")}</div>
                  <ul>
                    {relacionados.fuentesEfluentesLiquidos.map((fuente) => (
                      <li>{fuente.nombre}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosSolidosUrbanos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosSolidosUrbanos")}</div>
                  <ul>
                    {relacionados.residuosSolidosUrbanos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosPatogenicos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosPatogenicos")}</div>
                  <ul>
                    {relacionados.residuosPatogenicos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.residuosPeligrosos.length > 0 && (
                <li>
                  <div>{t("tramite.residuosPeligrosos")}</div>
                  <ul>
                    {relacionados.residuosPeligrosos.map((residuo) => (
                      <li>{residuo.descripcion}</li>
                    ))}
                  </ul>
                </li>
              )}
              {relacionados.ductos.length > 0 && (
                <li>
                  <div>{t("tramite.chimeneas")}</div>
                  <ul>
                    {relacionados.ductos.map((ducto) => (
                      <li>
                        {ducto.numeroDucto}&nbsp;-&nbsp;{ducto.referencia}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
          </>,
          t("operacionUnitariaForm.dialog.remove.accept"),
          t("operacionUnitariaForm.dialog.remove.decline"),
          (event) => {
            console.log(index);
            remove(index);
            dialog.close();
          },
          (event) => {
            dialog.close();
          },
        );
      }
    } else {
      console.log(index);
      remove(index);
    }
  };
  const handleSelectClick = (index) => (event) => {
    event.preventDefault();
    select(index);
    document.getElementById("operacionesUnitarias").scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <>
      {dialog.component}
      <ListGroup>
        {value?.map((operacionUnitaria, index) => (
          <ListGroupObjectItem
            key={operacionUnitaria.orden}
            index={index}
            value={operacionUnitaria}
            indexLabel={t("operacionUnitaria.orden")}
            deletable
            onDelete={handleDeleteClick(index)}
            editable
            onEdit={handleSelectClick(index)}
            disabled={disabled}
          >
            {({ value }) => (
              <>
                <LongTextValue
                  label={t("operacionUnitaria.nombre")}
                  value={value.nombre}
                />
                <LongTextValue
                  label={t("operacionUnitaria.descripcion")}
                  value={value.descripcion}
                />
              </>
            )}
          </ListGroupObjectItem>
        ))}
      </ListGroup>
    </>
  );
}
